<template>
  <div class="report">
    <div class="report-list-container" v-if="page == 'list'">
      <h1 class="title">请选择投诉原因</h1>
      <div class="complaint-list">
        <a :class="'complaint-item' + (item[1] !== undefined ? ' special-item' : '')"
          v-for="(item, index) in reportTypeList" :key="index" @click="handleChoiceType(item[0])">
          <template v-if="item[1] !== undefined">
            <div>
              <span>{{ item[0] }}</span>
              <p class="sub-text">{{ item[1] }}</p>
            </div>
          </template>
          <template v-else>
            <span>{{ item[0] }}</span>
          </template>
          <span class="arrow">›</span>
        </a>
      </div>
    </div>
    <div class="report-list-container" v-if="page == 'sub_type'">
      <h1 class="title">{{ reportSubTypeList[report_type][0] }}</h1>
      <div class="complaint-list">
        <a class="complaint-item" v-for="(item, index) in reportSubTypeList[report_type][1]" :key="index"
          @click="report_subtype = item, $router.push('/report/form?state='+state)">
          <span>{{ item }}</span>
          <span class="arrow">›</span>
        </a>
      </div>
    </div>
    <div class="report-form-container" v-if="page == 'form'">
      <div class="report-header">
        <h2>投诉内容</h2>
      </div>
      <div class="report-content">
        <div class="report-title">
          <h3>{{ event.name }}</h3>
          <div class="cover">
            <img :src="coverUrl" :alt="event.name" class="product-image">
          </div>
        </div>
        <div class="report-form">
          <div class="form-group">
            <div class="report-textarea"><van-field v-model="report_content" rows="3" type="textarea" maxlength="200"
                placeholder="请输入投诉内容" show-word-limit /></div>
          </div>
          <div class="evidence-upload">
            <h4>证据截图({{ reportList.length }}/4)</h4>
            <div class="upload-area">
              <van-uploader v-model="reportList" upload-icon="plus" :max-count="4" :max-size="1024 * 1024" multiple
                :after-read="onUploadAfterRead" @oversize="onUploadOversize" />
            </div>
          </div>
        </div>

        <button class="submit-button" :disabled="report_content.length == 0" @click="submitReport">提交</button>
      </div>
    </div>
    <div class="fangmao-page" v-if="page == 'fangmao'">
      <div class="fangmao-container">
        <div class="process-header">
          <h2>仿冒信息投诉流程</h2>
        </div>

        <div class="process-steps">
          <div class="step">
            <div class="step-number">1</div>
            <div class="step-content">
              <h3>准备举证资料</h3>
              <p>请查看以下文案说明</p>
            </div>
          </div>

          <div class="step">
            <div class="step-number">2</div>
            <div class="step-content">
              <h3>提交投诉</h3>
              <p>向我们提供仿冒方信息及投诉举证资料</p>
            </div>
          </div>

          <div class="step">
            <div class="step-number">3</div>
            <div class="step-content">
              <h3>待品牌方定定</h3>
              <p>品牌方进行专业审定，并反馈定定结果</p>
            </div>
          </div>

          <div class="step">
            <div class="step-number">4</div>
            <div class="step-content">
              <h3>处理被投诉内容</h3>
              <p>根据品牌方的意见进行处理</p>
            </div>
          </div>
        </div>

        <div class="evidence-section">
          <h3>准备举证资料示例：</h3>

          <div class="evidence-item">
            <h4>1. 商品照片</h4>
            <p>请提供发布仿冒商品信息的截图，例如商品详情页截图，示例如下：</p>
            <div class="image-placeholder">
              <img src="@/assets/fm-1.1.jpg" />
              <img src="@/assets/fm-1.jpg" />
            </div>
          </div>

          <div class="evidence-item">
            <h4>2. 交涉场景截图</h4>
            <p>提供在交易场景中的仿冒商品信息交易信息，如聊天、评论、私信等，示例如下：</p>
            <div class="image-placeholder"><img src="@/assets/fm-2.jpg" /></div>
          </div>

          <div class="evidence-item">
            <h4>3. 被投诉账号信息页</h4>
            <p>点击被投诉账号的头像，提供被投诉账号页面截图，示例如下：</p>
            <div class="image-placeholder">
              <img src="@/assets/fm-3.jpg" />
            </div>
          </div>
        </div>

        <div class="action-buttons">
          <button class="understand-btn" @click="$router.back()">我知道了</button>
          <button class="start-report-btn" @click="$router.push('/report/form?state='+state)">我已准备，开始投诉</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Toast } from 'vant'
import { showLive, reportFormSubmit } from '@/api'
import { reportUpload } from '@/utils/cos-upload'
import { wxInit } from '@/utils/auth';
try {
  wxInit()
} catch (e) { }
export default {
  name: 'Report',
  data() {
    return {
      submited: false,
      page: 'list',
      report_type: '',
      report_subtype: '',
      report_content: '',
      reportList: [],
      event: {
        announce: undefined,
        name: '直播',
        intro: undefined,
        video: {
          file_key: ""
        }
      },
      live: null,
    }
  },
  watch: {
    '$route': 'update'
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState(['user']),
    state() {
      if ('state' in this.$route.query) {
        return this.$route.query.state
      }
      return ''
    },
    coverUrl() {
      if ('cover_img' in this.event && this.event.cover_img) {
        return window.__config__.res_url + this.event.cover_img;
      }
      return ''
    },
    reportTypeList() {
      return [
        ['赌博'],
        ['骚扰'],
        ['欺诈骗钱'],
        ['传播不实信息'],
        ['违法犯罪'],
        ['违规营销'],
        ['网络水军'],
        ['发布仿冒品信息'],
        ['侵犯未成年人权益'],
        ['粉丝无底线追星'],
        ['其他'],
      ]
    },
    reportSubTypeList() {
      return {
        '骚扰': ['请选择骚扰类型', [
          '色情',
          '违法犯罪及违禁品',
          '政治谣言',
          '暴恐血腥',
          '泄露国家秘密',
          '自杀自残',
          '其他违规内容'
        ]],
        '欺诈骗钱': ['请选择欺诈类型', [
          '金融诈骗(贷款/提额/代开/套现等)',
          '网络兼职刷单诈骗',
          '返利诈骗',
          '网络交友诈骗',
          '虚假投资理财诈骗',
          '赌博诈骗',
          '仿冒他人诈骗',
          '游戏相关诈骗(代练/充值等)',
          '其他诈骗行为'
        ]],
        '传播不实信息': ['请选择传播不实信息类型', [
          '政治类不实信息',
          '医疗健康类不实信息',
          '社会事件类不实信息',
          '财经类不实信息',
          '疫情类不实信息',
          '标题煽动夸大误导'
        ]],
        '违规营销': ['请选择违规营销类型', [
          '金融营销风险',
          '虚假营销风险',
          '教育培训风险',
          '兼职培训风险',
          '房地产营销风险',
          '农业营销风险',
          '其他营销风险'
        ]],
      }
    }
  },
  methods: {
    async init() {
      const user = this.$store.state.user
      if (user && user.member_type > 0) {
        await this.onSuccess()
      } else {
        await this.loadLive()
      }
      this.submited = false;
    },
    handleChoiceType(type) {
      this.report_type = type;
      let page = 'form';
      if (type == '发布仿冒品信息') {
        page = 'fangmao';
      } else if (this.reportSubTypeList[type]) {
        page = 'sub_type';
      } else {
        page = 'form';
      }
      // this.page = page;
      this.$router.push('/report/' + page + '?type=' + type +'&state=' + this.state)
    },
    
    update() {
      // console.log(this.$route);
      if (this.$route.name == 'Report') {
        this.page = 'list'
      } else if (this.$route.name == 'ReportPage') {
        if ('params' in this.$route
          && 'page' in this.$route.params
          && ['fangmao', 'sub_type', 'form'].includes(this.$route.params.page)
        ) {
          let page = this.$route.params.page; 
          if ('type' in this.$route.query
            &&
            this.reportTypeList.includes(this.$route.query.type)
          ) {
            this.report_type = this.$route.query.type
          }
          if (!this.report_type) {
            page = 'list'
          }
          if (page == 'sub_type') {
            if (!this.reportSubTypeList[this.report_type]) {
              page = 'list'
            }
          }
          this.page = page
        }
      }
    },
    async submitReport() {
      let vm = this;
      if (this.submited) return;
      if (this.report_content.length == 0) {
        return Toast('请输入投诉内容')
      }
      let loading = Toast.loading({
        message: '请稍等',
        duration: 0,
      })
      let reportList = this.reportList.map((v) => {
        return v.objectKey
      }).filter((v) => {
        return typeof v == 'string';
      })
      try {
        this.submited = true;
        let resp = await reportFormSubmit(this.state, {
          content: this.report_content,
          type: this.report_type + '-' + this.report_subtype,
          image: reportList,
        })
        loading.clear();
        Toast('您的举报已提交，感谢您的支持')
        setTimeout(() => {
          vm.$router.back(vm.report_subtype ? -3: -2);
        }, 2000)
      } catch (e) {
        this.submited = false;
        loading.clear();
      }
    },
    async loadLive() {
      let loading = Toast.loading({
        message: '请稍等',
        duration: 0,
      })
      let resp
      let share_link
      try {
        resp = await showLive(this.state)
      } catch (e) {
        console.log('live error', e)
      }
      if (resp) loading.clear();
      this.is_guest = false;
      this.gm_message = undefined;
      this.redPackSended = false;
      if (resp.data.is_guest) {
        this.is_guest = true;
        this.event = resp.data.event
        this.gm_info = resp.data.gm_info
        this.prepareShare(resp);
        if (this.event.is_open == 0) {
          this.type = 'before_login'
          return;
        } else {
          this.type = resp.data.type
        }
      } else {
        this.type = resp.data.type
        this.$nextTick(() => {
          this.activeTab = 'question'
        })
        if ('gm_info' in resp.data) {
          this.gm_info = resp.data.gm_info
        }
        if (this.type == 'gm_error' && 'message' in resp.data) {
          this.gm_message = resp.data.message;
        }
      }

      if (this.type == 'event') {
        this.event = resp.data.event
      }
    },
    async onSuccess() {
      // this.showLogin = false
      if (!this.state) {
        return this.$router.replace('/error')
      }
      await this.loadLive()
    },
    onError() {
      this.$router.replace('/error')
    },
    onUploadAfterRead(e) {
      e.status = 'uploading';
      e.message = '上传中...';

      let that = this;
      reportUpload({
        ...e,
        onError(err) {
          e.status = 'fail';
          e.message = '上传失败'
          console.log('onError', err)
        },
        onSuccess(evt) {
          console.log('onSuccess', { evt, e })
          e.status = 'done';
          e.objectUrl = evt.objectUrl;
          e.objectKey = evt.Key;
        }
      })
    },
    onUploadOversize(file) {
      Toast('文件大小不能超过 1MB');
    }
  }
}
</script>

<style lang="scss" scoped>
.report {
  width: 100%;

  .header {
    height: 60px;
    padding: 10px;
    line-height: 40px;
    overflow: hidden;
    word-break: keep-all;
    text-align: center;
    background: #fff;
  }

  .report-list-container {
    max-width: 600px;
    margin: 0 auto;
    padding: 0 0 60px;

    .title {
      font-size: 18px;
      font-weight: normal;
      text-align: center;
      margin: 60px 0 60px;
    }

    .complaint-list {
      background-color: #fff;
      border-radius: 8px;
    }

    .complaint-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #eee;
      text-decoration: none;
      color: #333;
    }

    .complaint-item:last-child {
      border-bottom: none;
    }

    .arrow {
      color: #ccc;
      font-size: 20px;
    }

    .special-item {
      align-items: flex-start;
    }

    .sub-text {
      font-size: 12px;
      color: #999;
      margin-top: 4px;
      line-height: 1.4;
    }

    /* 添加点击效果 */
    .complaint-item:active {
      background-color: #f5f5f5;
    }
  }

  .report-form-container {
    max-width: 600px;
    margin: 0 auto;
    min-height: 100vh;
    display: flex;
    flex-direction: column;

    .report-header {
      padding: 48px 30px 10px 30px;
      background-color: #f7f7f7;
    }

    .report-header h2 {
      font-size: 14px;
      font-weight: normal;
      margin: 0;
      color: #666;
    }

    .report-content {
      flex: 1;
      background-color: #fff;
      padding-bottom: 10px;
    }

    .report-title {
      padding: 5px 30px 30px 30px;
      background: #f7f7f7;
      border-bottom: 1px solid #eee;
      display: flex;
      justify-content: space-between;
    }

    .report-title h3 {
      flex: 1;
      font-size: 16px;
      font-weight: normal;
      margin-bottom: 10px;
    }

    .product-image {
      flex: 60px 0 0;
      width: 60px;
      height: 60px;
      object-fit: cover;
    }

    .report-form {
      padding: 15px 10px 60px 10px;
    }

    .form-group {
      position: relative;
      margin-bottom: 10px;
    }

    .report-textarea {
      width: 100%;
      overflow: hidden;
      border-radius: 4px;
      font-size: 14px;
    }

    .word-count {
      position: absolute;
      bottom: 10px;
      right: 10px;
      color: #999;
      font-size: 12px;
    }

    .evidence-upload {
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
    }

    .evidence-upload h4 {
      padding: 10px 10px 0 10px;
      font-size: 14px;
      font-weight: normal;
      margin: 10px 0;
    }

    .upload-area {
      padding: 10px;
    }

    .upload-button {
      width: 100px;
      height: 100px;
      border: 1px dashed #ddd;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f9f9f9;
    }

    .plus {
      font-size: 30px;
      color: #ccc;
    }

    .submit-button {
      width: 180px;
      left: 50%;
      transform: translateX(-90px) translateY(20px);
      padding: 15px;
      background-color: #e6e6e6;
      color: #fff;
      border: none;
      font-size: 16px;
      position: sticky;
      border-radius: 8px;
    }

    .submit-button:not([disabled]) {
      background-color: #07c160;
    }

    /* 添加一些交互效果 */
    .report-textarea:focus {
      outline: none;
      border-color: #07c160;
    }

    .upload-button:active {
      background-color: #f0f0f0;
    }
  }
}
.fangmao-page {
  width: 100%;
  background: #fff;
}
.fangmao-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 0 30px 60px 30px;
  
  .process-header h2 {
    padding: 48px 30px 10px 30px;
    text-align: center;
    font-size: 18px;
    margin-bottom: 30px;
  }

  .process-steps {
    margin-bottom: 30px;
  }

  .step {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
  }

  .step-number {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #f0f0f0;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    flex-shrink: 0;
  }

  .step-content h3 {
    font-size: 16px;
    margin: 0 0 5px 0;
  }

  .step-content p {
    margin: 0;
    color: #666;
    font-size: 14px;
  }

  .evidence-section {
    margin-top: 30px;
  }

  .evidence-section h3 {
    font-size: 16px;
    margin-bottom: 20px;
  }

  .evidence-item {
    margin-bottom: 25px;
  }

  .evidence-item h4 {
    font-size: 14px;
    margin: 0 0 10px 0;
  }

  .evidence-item p {
    font-size: 14px;
    color: #666;
    margin: 0 0 10px 0;
  }

  .image-placeholder {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    margin: 10px 0;
  }
  .image-placeholder img {
    height: 150px;
  }

  .action-buttons {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .understand-btn,
  .start-report-btn {
    width: 100%;
    padding: 12px 0;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
  }

  .understand-btn {
    background-color: #07c160;
    color: white;
  }

  .start-report-btn {
    background-color: white;
    color: #07c160;
    border: 1px solid #07c160;
  }

  .footer {
    margin-top: 20px;
    text-align: center;
  }

  .platform-link {
    color: #576b95;
    text-decoration: none;
    font-size: 14px;
  }
}

.gm_error {
  width: 90vw;
  padding: 6px 12px;

  .title {
    font-size: 18px;
    padding: 6px 0 12px;
    border-bottom: 1px solid #999;
    margin-bottom: 6px;
    text-align: center;
  }

  .content {
    padding: 6px 0;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}

.headicon {
  width: 50px;
  height: 50px;
  border-radius: 25px;
}

.action-redpack {
  position: fixed;
  bottom: 30px;
  left: 50%;
  width: 80vw;
  transform: translateX(-40vw);
  font-size: 32px;
}

.friendcode {
  width: 60vw;

  img {
    width: 100%;
    height: auto;
  }
}
</style>
<style lang="scss">
.intro {
  img {
    width: 100%;
    height: auto;
  }
}

.report .report-form-container .report-textarea .van-cell {
  padding: 10px;
}
</style>